import { render } from "./PrintWatermark.vue?vue&type=template&id=db66bdfa&scoped=true"
import script from "./PrintWatermark.vue?vue&type=script&lang=js"
export * from "./PrintWatermark.vue?vue&type=script&lang=js"

import "./PrintWatermark.vue?vue&type=style&index=0&id=db66bdfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db66bdfa"]])

export default __exports__